import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';

import { TicketUpdateForm } from './common/TicketForms';


function ChatMessage({followUp}){

  let attachment = false;
  if (followUp.attachments.length > 0){
    attachment = followUp.attachments[0]
  }

  const usertype = followUp.user.userprofile.usertype;
  const isLab = usertype === 'LAB';
  // LAWYER и SPECIALIST показываем под единым ярлыком «Специалист АСНП»
  const isStaff = usertype === 'LAWYER' || usertype === 'SPECIALIST';
  const isCloseEvent = followUp.new_status === 'CLOSED';

  if (isCloseEvent) {
    return (
      <>
        <div className="alert alert-secondary text-center" role="alert">
          <p className="mb-0">Обращение закрыто</p>
        </div>
        <div className="d-grid d-md-flex justify-content-between">
          {isLab && <span className='message-date'>Вы:</span>}
          {isStaff && <span className='message-date'>Специалист АСНП:</span>}
          <span className='message-date'>{followUp.date}</span>
        </div>
      </>
    );
  }

  return (
    <>
      {isLab &&
        <div className="alert alert-primary" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} className="alert-link">приложенный файл</a> : <></> }
        </div>
      }
      {isStaff &&
        <div className="alert alert-info" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} className="alert-link">приложенный файл</a> : <></> }
        </div>
      }
      <div className="d-grid d-md-flex justify-content-between">
        {isLab && <span className='message-date'>Вы:</span>}
        {isStaff && <span className='message-date'>Специалист АСНП:</span>}
         <span className='message-date'>{followUp.date}</span>
      </div>

    </>
  );
}


export default function TicketUpdate({selectedYear}){
  const[ticket, setTicket] = useState(Object());
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  let { ticketId } = useParams();
  const isClosed = ticket.status === 'CLOSED';

  React.useEffect(() => {

    let apiReturnedTicket = axios_api.get(api_url + '/ticket/' + ticketId, {
      headers: {"Authorization": token}
    });

    apiReturnedTicket.then(
      (result) => {
        setTicket(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);


  let lastMessageUserRole = false;
  let rows = [];

  if (ticket.follow_ups) { 

    for (let i in ticket.follow_ups) {
      if ( +i === 0) {
        lastMessageUserRole = ticket.follow_ups[i].user.userprofile.usertype
      }
      rows.push(
        <>
          <ChatMessage 
            key={i} 
            followUp={ticket.follow_ups[i]} 
          />
        </>
      ); 
    }
  }
  
  return (
    <>
      <div className="row">
        <h3 className="m-3">Обращение № {ticket.id}</h3>
        {ticket.theme?.theme_name &&
          <h6 className="ms-3 mt-0">Тема - {ticket.theme.theme_name}</h6>
        }
      </div>
      {isClosed &&
        <p className='ms-3 mb-0 text-secondary'>Обращение закрыто{ticket.closed_at ? ` ${ticket.closed_at}` : ''}</p>
      }
      <div className='row mt-2 m-3'>
        <div className='col-6 ps-0'>
          <div className='px-5 py-4 vh-75 chat-background overflow-scroll'>
            {(!isClosed && lastMessageUserRole === 'LAB') && <span className='message-date'>Ожидается ответ специалиста АСНП...</span>}     
            {rows}
            <div className="d-grid d-md-flex justify-content-center">
              <span className='message-date'>-- начало переписки --</span>
            </div>
          </div>
        </div>
        <div className='col-6 ps-5'>
          {isClosed ?
            <p className="text-secondary">В закрытое обращение нельзя добавить сообщение</p>
          :
            <TicketUpdateForm
              ticketId={ticket.id} 
            />
          }
        </div>                     
    </div> 
    </>
  );
}
